import { getAccountId } from 'api/auth';
import axiosApi from 'utils/axios';
import { axiosGetAutoCancelDecorator } from 'utils/axiosGetAutoCancelDecorator';

export const startGeneration: StartGeneration = async (params) => {
  const accountId = getAccountId();
  return axiosApi.post(`acc/${accountId}/generative_contents`, params).then(({ data }) => data);
};
export const retryGeneration: RetryGeneration = async (params) => {
  const accountId = getAccountId();
  const data = await axiosApi
    .post(`/acc/${accountId}/generative_contents/${params.generationData.id}/regenerate`)
    .then(({ data }) => data);
  return data;
};

const decoratedAxiosGet = axiosGetAutoCancelDecorator();
export const checkGenerationStatus: CheckGenerationStatus = async (params) => {
  const accountId = getAccountId();
  return decoratedAxiosGet(`/acc/${accountId}/generative_contents/${params.generationData.id}/status`).then(
    ({ data }) => data,
  );
};

export const getGenerationResult: GetGenerationResult = async (params) => {
  const accountId = getAccountId();
  return axiosApi
    .get(`/acc/${accountId}/generative_contents/${params.generationData.id}/result`)
    .then(({ data }) => data);
};

export const rateGeneration: RateGeneration = async (params) => {
  const accountId = getAccountId();
  return await axiosApi.post(`/acc/${accountId}/generative_contents/${params.generationData.id}/evaluate`, {
    evaluation: params.aditionalData.evaluation,
  });
};

export type StartGenerationParams = {
  sourceType: 'page' | 'trip_event';
  sourceId: number;
  message: string;
};
type StartGenerationResponse = { id: number };
type StartGeneration = (params: StartGenerationParams) => Promise<StartGenerationResponse>;
type RetryGeneration = (params: { generationData: StartGenerationResponse }) => Promise<StartGenerationResponse>;
type CheckGenerationStatus = (params: { generationData: StartGenerationResponse }) => Promise<{
  status: 'pending' | 'invalid_context' | 'failed' | 'completed';
}>;
type GetGenerationResult = (params: { generationData: StartGenerationResponse }) => Promise<PageGenerationResult>;
type RateGeneration = (params: {
  generationData: StartGenerationResponse;
  aditionalData: {
    evaluation: 'positive' | 'negative';
  };
}) => Promise<{ status: 'ok' | 'failed' }>;
export type PageGenerationResult = {
  content: string;
};
